/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import React from 'react';
import DefaultDashboardLayout from 'layouts/dashboard/DefaultDashboardLayout';
import Box from 'components/generals/Box';
import Card from '@mui/material/Card';
import MDBox from 'dashboard-template/components/MDBox';
import ActivityLogDataContent from 'components/content/ActivityLogDataContent';
import AdminRouteGuard from 'components/guards/AdminRouteGuard';

/**
 * System activity audit log page (Admin-only).
 * 
 * Features:
 * - Comprehensive audit trail of system activities
 * - User action tracking (login, data access, modifications)
 * - Filterable log entries by user, action type, date range
 * - Search functionality for specific events
 * - Export capabilities for compliance reporting
 * - Admin-only access with AdminRouteGuard protection
 * 
 * This page supports ISO-27001 compliance requirements for
 * audit logging and security monitoring.
 * 
 * @returns Activity logs page component (admin access required)
 */
const ActivityLogsPage: React.FC = () => {
  return (
    <AdminRouteGuard>
      <DefaultDashboardLayout>
        <Box>
          <Card>
            <MDBox p={3}>
              <ActivityLogDataContent />
            </MDBox>
          </Card>
        </Box>
      </DefaultDashboardLayout>
    </AdminRouteGuard>
  );
};

export default ActivityLogsPage;
